import React from 'react';
import PropTypes from 'prop-types';

export class DepartmentSelect extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            departmentSelected: undefined,
            currentDept: undefined
        }
        this.clickOnDept = this.clickOnDept.bind(this)
        this.applyDeptChange = this.applyDeptChange.bind(this)
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.initialState && this.props.initialState !== nextProps.initialState) {
            this.setState({
                departmentSelected: undefined,
                currentDept: undefined
            })
        }
        if (this.props.departmentSelected !== nextProps.departmentSelected) {
            if (!(this.state.departmentSelected && nextProps.departmentSelected && this.state.departmentSelected.id === nextProps.departmentSelected.id)) {
                this.setState({
                    departmentSelected: nextProps.departmentSelected,
                    currentDept: (nextProps.departmentSelected && nextProps.departmentSelected.id),
                    showError: false
                })
            }
        }
    }

    clickOnDept(e) {
        this.setState({currentDept: e.target.value, showError: false});
    }

    applyDeptChange(e) {
        if (this.props.clickOnDept) {
            let idDept = this.state.currentDept;
            if (idDept) {
                let deptName = this.props.departments.find(dept => dept.code === idDept).nom;
                this.props.clickOnDept(idDept, deptName);
            } else {
                this.setState({showError: true}, () => this._selectNode.focus());
            }
        }
    }

    render() {
        return (

            <div className="region-select">
                <div className={`form-group ${this.state.showError ? 'has-error' : ''}`}>
                    <label htmlFor="field-error" for="general-selector-department">Sélectionnez un département</label>
                    <div className="general-selector-container">
                        <div className="field-item" id={`${this.state.showError ? 'field-error' : ''}`}>
                            <select id="general-selector-department" className="general-selector" value={(this.state.currentDept) || ''} onChange={this.clickOnDept} aria-required={true} aria-invalid={this.state.showError} aria-describedby={`${this.state.showError ? 'error-dept-msg' : ''}`} ref={ (node) => {this._selectNode = node} }>
                                <option value="">Sélectionnez un département</option>
                                {this.props.departments.map(dept => <option key={dept.code} value={dept.code}>{dept.nom}</option>)}
                            </select>
                            <button onClick={this.applyDeptChange}>Valider</button>
                        </div>
                        {this.state.showError && <p className="help-block" id="error-dept-msg">Veuillez sélectionner un département dans la liste.</p>}
                    </div>
                </div>
            </div>

        )
    }
}

DepartmentSelect.propTypes = {
    clickOnDept: PropTypes.func,
    departments: PropTypes.array,
    departmentSelected: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired
    })
}
